<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <h4 class="modalTitle">Share</h4>
        <div class="selectorCnt">
          <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareEncoded}`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-facebook.png">
            <h4>Post</h4>
          </a>
          <a :href="`https://twitter.com/intent/tweet?url=${shareEncoded}&text=${escapedTitle}
            &hashtags=BumiButhAksi,TenggelamDalamDiam
            &related=bumibutuhaksi,Mengabarkan Kita Tenggelam,pamera virtual`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-twitter.png">
            <h4>Tweet</h4>
          </a>
          <a :href="`https://api.whatsapp.com/send/?phone&text=${waText}&app_absent=0`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-wa.png">
            <h4>Send</h4>
          </a>
          <a :href="`https://id.pinterest.com/pin-builder/?url=${shareEncoded}&description=${escapedTitle}&is_video=false&media=${escapedMedia}&method=button`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-pinterest.png">
            <h4>Pinterest</h4>
          </a>
          <a :href="`mailto:?subject=${escapedTitle}&body=${waText}`"
            target="_blank" class="selectorItem">
            <img src="../assets/envelope.png">
            <h4>Email</h4>
          </a>
        </div>
        <div class="shareLink">
          {{shareUri}}
          <div class="copy" v-on:click="copyToClp(shareUri)">SALIN</div>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'confirmation',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      shareUri: '',
      shareEncoded: '',
      escapedTitle: '',
      escapedMedia: '',
      waText: '',
    };
  },
  methods: {
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Link copied to clipboard.' });
    },
    open(d, next) {
      const r1 = d.category.slug;
      const r2 = (d.categories.length > 0) ? d.categories[0].category.slug : 'read';
      this.shareUri = `https://nutrilite.co.id/${r1}/${r2}/${d.slug}`;
      this.shareEncoded = escape(this.shareUri);
      this.escapedTitle = escape(d.title);
      this.waText = escape(d.title);
      this.escapedMedia = (d.thumb) ? escape(d.thumb) : '';
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
  },
};
</script>

<style scoped lang="scss">
  .shareLink{
    margin: 20px 26px 4px;
    background-color: #f5f5f5;
    border: #ccc 1px solid;
    border-radius: 3px;
    color: #222;
    padding: 10px 12px;
    padding-right: 70px;
    box-sizing: border-box;
    max-width: 410px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    @media (max-width: 680px) {
      margin: 20px 0 4px;
    }
    .copy{
      position: absolute;
      right: 4px; top: 4px;
      font-weight: 600;
      color: #005ab5;
      font-size: 14px;
      padding: 8px 10px 7px;
      border-radius: 3px;
      cursor: pointer;
      &:hover{
        background-color: #ddd;
      }
    }
  }

  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      .modalTitle{
        padding: 20px 100px 10px;
        font-size: 28px;
        margin: -30px -80px 24px;
        background-color: #eee;
      }
      .selectorCnt{
        display: flex;
        justify-content: center;
        .selectorItem{
          padding: 14px 20px 10px;
          border: #fff 1px solid;
          border-radius: 5px;
          transition: all .2s ease;
          position: relative;
          text-align: center;
          &:hover{
            opacity: 1;
            // border-color: #f5f5f5;
            // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #444;
          }
          img{
            height: 30px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
</style>
